import apiClient from '../client';
import {
  BASE_ENDPOINTS,
  SERVICES,
  VERSIONS,
  RESOURCES
} from '../common/constants';

const SUPPLIER_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.SUPPLIER,
  false // No tenant ID in the base URL
);

export const supplierApi = {
  getSupplierList: () => apiClient.get(`${SUPPLIER_BASE}/list`),
  getSupplier: id => apiClient.get(`${SUPPLIER_BASE}/${id}`),
  createSupplier: combinedData =>
    apiClient.post(`${SUPPLIER_BASE}`, combinedData),
  updateSupplier: (id, combinedData) =>
    apiClient.put(`${SUPPLIER_BASE}/${id}`, combinedData),
  deleteSupplier: id => apiClient.delete(`${SUPPLIER_BASE}/${id}`)
};
export default supplierApi;
